module.exports = __webpack_public_path__ + "img/dashboardlogo.10c57edf.svg";